export const SLATE_VERSION = 1;
